import React, { useState, useEffect, useRef } from "react";
//redux
import { connect } from "react-redux";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
import Dialog from '../../../../components/Backdrops/Dialog';
import { useLocation } from "react-router-dom";
import moment from "moment";
//service
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import adminUserService from "../../../../utils/services/accreditation/adminUser";
import scheduleService from "../../../../utils/services/accreditation/schedule";
import adminActionService from "../../../../utils/services/accreditation/adminAction";
import groupService from "../../../../utils/services/accreditation/group";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import AdminActionModel from "../../../../utils/models/AdminActionModel";

import ActionsList from './ActionsList';
import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import ModalActionControl from './ModalActionControl';
import ModalFilterData from './ModalFilterData';
import ModalErrorLog from './ModalErrorLog';
import ModalLog from './ModalLog';
import ModalTrash from './ModalTrash';

const defaultWhatsappTagsForm = {
  tag1: '',
  tag2: '',
  tag3: '',
  tag4: '',
  tag5: '',
  tag6: '',
  tag7: '',
  tag8: '',
  tag9: '',
  tag10: '',
}

function AccreditationActionsPage(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [dialogActionControl, setDialogActionControl] = React.useState({
    open: false,
    title: '',
    message: '',
    icon: 'info',
    command: '',
    actionId: '',
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = useRef(plusXMiceId);
  useEffect(() => {
    plusXMiceIdRef.current = plusXMiceId;
  }, [plusXMiceId]);
  const [eventActions, setEventActions] = React.useState([]);
  const [whatsappTemplates, setWhatsappTemplates] = React.useState([]);
  const [guestGroups, setGuestGroups] = React.useState([]);
  const [eventSchedules, setEventSchedules] = React.useState([]);
  const [attributesListLabel, setAttributesListLabel] = React.useState([]);
  const [modalActionControl, setModalActionControl] = React.useState({
    open: false,
  });
  const [modalTrashControl, setModalTrashControl] = React.useState({
    open: false,
    actions: []
  });
  const [modalLogControl, setModalLogControl] = React.useState({
    open: false,
    action: AdminActionModel()
  });
  const [modalErrorsControl, setModalErrorsControl] = React.useState({
    open: false,
    errors: []
  });
  const [modalFilterDataControl, setModalFilterDataControl] = React.useState({
    open: false,
    orderBy: 'id',
    search: '',
    scheduleFilter: '',
    groupFilter: '',
    typeFilter: '',
  });
  const [newActionForm, setNewActionForm] = React.useState(AdminActionModel());
  const newActionFormRef = React.useRef(AdminActionModel());
  useEffect(() => {
    newActionFormRef.current = newActionForm;
  }, [newActionForm]);
  const [whatsappTagsForm, setWhatsappTagsForm] = React.useState({ ...defaultWhatsappTagsForm });

  useEffect(() => {
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
      setPlusXMiceId(_plusXMiceId);

      setTimeout(() => {
        getEventData();
      }, 100);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getEventData = React.useCallback(async () => {
    try {
      if (!plusXMiceIdRef.current.active) {
        return;
      }

      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _token = await adminUserService.getAdminTokenApi(plusXMiceIdRef.current.miceId);

      let _actions = await adminActionService.getActionsApi(plusXMiceIdRef.current.miceId);
      setEventActions(_actions);

      let _whatsappTemplates = await adminActionService.getTemplateListApi(plusXMiceIdRef.current.miceId);
      setWhatsappTemplates(_whatsappTemplates);

      let _groups = await groupService.getGroupsApi(plusXMiceIdRef.current.miceId);
      let _finalGroups = [
        { value: '', text: 'Todos' },
        { value: '1', text: `Apenas participantes sem grupo` },
        ..._groups
      ];
      setGuestGroups(_finalGroups);

      let _schedules = await scheduleService.getSchedulesHallApi(plusXMiceIdRef.current.miceId);
      setEventSchedules(_schedules);

      let _attributes = await adminUserService.getAttributesListApi(_token, plusXMiceIdRef.current.miceId);

      let _attributesListLabel = getFilteredAttributesListLabel(_attributes);
      setAttributesListLabel(_attributesListLabel);

    } catch (error) {
      console.log('Error getEventData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function getFilteredAttributesListLabel(attributes = []) {
      let _return = [{
        text: '',
        value: '',
        dbReference: ''
      }];
      attributes.forEach(item => {
        _return.push({
          text: item.Nome,
          value: item.ID,
          dbReference: item.DbReferencia || item.Nome
        });
      });
      return _return;
    }
  }, [plusXMiceId, plusXMiceIdRef]);

  const closeModalActionControl = React.useCallback(() => {
    setNewActionForm(AdminActionModel());
    setWhatsappTagsForm({ ...defaultWhatsappTagsForm });
    setModalActionControl({ ...modalActionControl, open: false });
  }, [defaultWhatsappTagsForm, modalActionControl, newActionForm]);

  const openNewAction = React.useCallback(() => {
    setNewActionForm(AdminActionModel({ serverNumber: '1' }));
    setModalActionControl({ ...modalActionControl, open: true });
    setWhatsappTagsForm({ ...defaultWhatsappTagsForm });
  }, [defaultWhatsappTagsForm, modalActionControl, newActionForm]);

  const openEditAction = React.useCallback((action = AdminActionModel()) => {
    let _newActionForm = { ...action };
    for (var key in action) {
      _newActionForm[key] = action[key] ? action[key].toString() : '';
    }
    setNewActionForm(_newActionForm);
    getAttributesTagForm(action);
    setModalActionControl({ ...modalActionControl, open: true });
  }, [newActionForm, modalActionControl]);

  const openCopyAction = React.useCallback((action = AdminActionModel()) => {
    let _newActionForm = { ...action };
    for (var key in action) {
      _newActionForm[key] = action[key] ? action[key].toString() : '';
    }
    getAttributesTagForm(action);
    _newActionForm.id = '';
    setNewActionForm(_newActionForm);
    setModalActionControl({ ...modalActionControl, open: true });
  }, [newActionForm, modalActionControl]);

  const getAttributesTagForm = React.useCallback((action = AdminActionModel()) => {
    if (action.templateId && action.numberOfTags > 0) {
      let _whatsappTagsForm = { ...whatsappTagsForm };
      for (let index = 0; index < action.numberOfTags; index++) {
        const _key = `tag${index + 1}`;
        _whatsappTagsForm[_key] = action.attributeTags[index].id.toString();
      }
      setWhatsappTagsForm(_whatsappTagsForm);
    }
  }, [whatsappTagsForm]);

  const trySaveAction = React.useCallback(async (values) => {
    try {
      setLoadingControl({ message: 'Salvando', open: true });

      let _errorMessage = validateForm();
      if (_errorMessage) {
        setAlertControl({
          open: true,
          title: 'Erro',
          message: _errorMessage,
          icon: 'error'
        });
        return;
      }

      let _values = addDataToValues();
      _values.log = getLog(_values);

      let _ret = await adminActionService.saveActionApi(_values);

      if (!_values.id) {
        let _actions = [...eventActions, _ret];
        setEventActions(_actions);
      } else {
        let _index = eventActions.findIndex(a => { return a.id === _ret.id });
        let _actions = [...eventActions];
        _actions[_index] = _ret;
        setEventActions(_actions);
      }

      closeModalActionControl();

      setAlertControl({
        open: true,
        title: '',
        message: 'Ação salva com sucesso',
        icon: 'success'
      });
    } catch (error) {
      console.log('Error trySaveAction', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function validateForm() {
      try {
        if (!values.type) {
          return `Campo 'Tipo Ação' obrigatório`;
        }
        if (!values.scheduleId) {
          return `Campo 'Programação' obrigatório`;
        }
        if (values.type === 'whatsapp' && !values.templateId) {
          return `Campo 'Template' obrigatório`;
        }
        if (values.type === 'whatsapp' && values.templateId) {
          let _template = whatsappTemplates.find(t => { return t.value === values.templateId });
          for (let index = 0; index < _template.numberOfTags; index++) {
            const _key = `tag${index + 1}`;
            if (!whatsappTagsForm[_key]) {
              return `Campo 'Tag${index + 1}' obrigatório`;
            }
          }
        }
        if (values.type === 'whatsapp' && values.templateId) {
          let _template = whatsappTemplates.find(t => { return t.value === values.templateId });
          if (_template.hasUrl && !values.url) {
            return `Campo 'Url ${_template.urlType === 'DOCUMENT' ? 'Documento' : _template.urlType === 'VIDEO' ? 'Vídeo' : 'Imagem'}' obrigatório`;
          }
        }
        if (values.type === 'whatsappOrganizer' && values.organizerCellPhone.length < 14) {
          return `Campo 'Telefone Organizador' obrigatório`;
        }
        if ((values.type === 'whatsapp' || values.type === 'whatsappOrganizer') && !values.serverNumber) {
          return `Campo 'Número de Envio Servidor' obrigatório`;
        }

        return '';
      } catch (error) {
        throw error;
      }
    }

    function addDataToValues() {
      try {
        let _values = AdminActionModel(values);

        _values.eventId = plusXMiceIdRef.current.miceId;

        if (_values.templateId) {
          let _template = whatsappTemplates.find(t => { return t.value === _values.templateId });
          _values.numberOfTags = _template.numberOfTags;
          _values.hasUrl = _template.hasUrl;
          _values.urlType = _template.urlType;

          let _attributes = [];
          for (let index = 0; index < _template.numberOfTags; index++) {
            const _key = `tag${index + 1}`;
            let _attribute = attributesListLabel.find(a => { return a.value.toString() === whatsappTagsForm[_key].toString() });
            _attributes.push({
              id: parseInt(whatsappTagsForm[_key]),
              dbReference: _attribute.dbReference || '',
            });
          }
          _values.attributeTags = _attributes;
        } else {
          _values.numberOfTags = 0;
          _values.hasUrl = false;
          _values.urlType = '';
          _values.attributeTags = [];
        }

        if (_values.groupId) {
          let _group = guestGroups.find(g => { return g.value.toString() === _values.groupId.toString() });
          _values.groupName = _group?.text || '';
        } else {
          _values.groupName = '';
        }

        if (_values.scheduleId) {
          let _schedule = eventSchedules.find(g => { return g.value.toString() === _values.scheduleId.toString() });
          _values.scheduleName = _schedule?.text || '';
        } else {
          _values.scheduleName = '';
        }

        return _values;
      } catch (error) {
        console.log('Error addDataToValues', error);
        throw error;
      }
    }

    function getLog(newAction = AdminActionModel()) {
      try {
        let _log = '';

        let _data = {
          user: eventId,
          date: moment().format(),
          action: '',
          obs: '',
        }

        if (!newAction.id) {
          _data.action = 'CREATE';
          _log = JSON.stringify([_data]);
        } else {
          _data.action = 'UPDATE';
          let _oldAction = eventActions.find(a => { return a.id === newAction.id });
          for (var key in newAction) {
            if (key !== 'log') {
              if (Array.isArray(newAction[key])) {
                if (JSON.stringify(newAction[key]) !== JSON.stringify(_oldAction[key])) {
                  let _text = `${key} FROM ${JSON.stringify(_oldAction[key])} TO ${JSON.stringify(newAction[key])}`;
                  _data.obs = _data.obs + (_data.obs ? ', ' : '') + _text;
                }
              } else if (typeof newAction[key] === "boolean") {
                if (newAction[key] !== _oldAction[key]) {
                  let _text = `${key} FROM ${_oldAction[key] === true ? 'true' : 'false'} TO ${newAction[key] === true ? 'true' : 'false'}`;
                  _data.obs = _data.obs + (_data.obs ? ', ' : '') + _text;
                }
              } else if ((parseInt(newAction[key]) && parseInt(newAction[key]) >= 0) || (parseInt(_oldAction[key]) && parseInt(_oldAction[key]) >= 0)) {
                let _newNumber = newAction[key] ? newAction[key].toString() : '0';
                let _oldNumber = _oldAction[key] ? _oldAction[key].toString() : '0';
                if (_newNumber !== _oldNumber) {
                  let _text = `${key} FROM ${_oldNumber} TO ${_newNumber}`;
                  _data.obs = _data.obs + (_data.obs ? ', ' : '') + _text;
                }
              } else {
                let _newValue = newAction[key] || '';
                let _oldValue = _oldAction[key] || '';
                if (_newValue !== _oldValue) {
                  let _text = `${key} FROM ${_oldValue} TO ${_newValue}`;
                  _data.obs = _data.obs + (_data.obs ? ', ' : '') + _text;
                }
              }
            }
          }
          let _totalData = _oldAction.log ? JSON.parse(_oldAction.log) : [];
          _totalData.push(_data);
          _log = JSON.stringify(_totalData);
        }

        return _log;
      } catch (error) {
        console.log('Error getLog', error);
        throw error;
      }
    }
  }, [eventActions, loadingControl, whatsappTemplates, whatsappTagsForm, attributesListLabel, guestGroups, eventSchedules]);

  const openDialogDeleteAction = React.useCallback(async (action = AdminActionModel()) => {
    setDialogActionControl({
      ...dialogActionControl,
      open: true,
      title: 'Atenção',
      message: `Tem certeza que deseja deletar a ação ID '${action.id}'?`,
      icon: 'danger',
      command: 'delete',
      actionId: action.id,
    });
  }, [dialogActionControl]);

  const tryDeleteAction = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Salvando', open: true });

      let _action = eventActions.find(a => { return a.id === dialogActionControl.actionId });
      _action.log = getLog(_action);
      await adminActionService.saveActionApi(_action);

      await adminActionService.deleteActionApi(_action);

      setDialogActionControl({ ...dialogActionControl, open: false, icon: 'info' });

      let _actionsList = eventActions.filter(a => { return a.id !== _action.id });
      setEventActions(_actionsList);

      setAlertControl({
        open: true,
        title: '',
        message: 'Ação deletada com sucesso',
        icon: 'success'
      });
    } catch (error) {
      console.log('Error tryDeleteAction', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function getLog(action = AdminActionModel()) {
      try {
        let _log = '';

        let _data = {
          user: eventId,
          date: moment().format(),
          action: 'DELETE',
          obs: '',
        }

        let _totalData = action.log ? JSON.parse(action.log) : [];
        _totalData.push(_data);
        _log = JSON.stringify(_totalData);

        return _log;
      } catch (error) {
        console.log('Error getLog', error);
        throw error;
      }
    }
  }, [dialogActionControl, eventActions, loadingControl]);

  const getFilteredData = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Carregando', open: true });

      let _actions = await adminActionService.getActionsApi(
        plusXMiceIdRef.current.miceId,
        modalFilterDataControl.orderBy,
        modalFilterDataControl.search,
        modalFilterDataControl.scheduleFilter,
        modalFilterDataControl.groupFilter,
        modalFilterDataControl.typeFilter,
      );
      setEventActions(_actions);

      setModalFilterDataControl({ ...modalFilterDataControl, open: false });

    } catch (error) {
      console.log('Error getFilteredData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [loadingControl, modalFilterDataControl]);

  const getTrashDataAndOpenModal = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Carregando', open: true });

      let _actions = await adminActionService.getActionsTrashApi(plusXMiceIdRef.current.miceId);

      setModalTrashControl({ ...modalTrashControl, open: true, actions: _actions });

    } catch (error) {
      console.log('Error getTrashDataAndOpenModal', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [loadingControl, modalTrashControl]);

  const getErrorsDataAndOpenModal = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Carregando', open: true });

      let _errors = await adminActionService.getActionsErrorsApi(plusXMiceIdRef.current.miceId);

      setModalErrorsControl({ ...modalErrorsControl, open: true, errors: _errors });

    } catch (error) {
      console.log('Error getErrorsDataAndOpenModal', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [loadingControl, modalErrorsControl]);

  const getTypeText = React.useCallback((type) => {
    switch (type) {
      case 'whatsapp':
        return 'Whatsapp';
        break;
      case 'whatsappOrganizer':
        return `Whatsapp Organizador`;
        break;
      default:
        return '';
        break;
    }
  }, []);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  if (modalActionControl.open) {
    return (
      <>
        <ModalActionControl
          setNewActionForm={setNewActionForm}
          newActionForm={newActionForm}
          trySaveAction={trySaveAction}
          whatsappTemplates={whatsappTemplates}
          guestGroups={guestGroups}
          eventSchedules={eventSchedules}
          closeModalActionControl={closeModalActionControl}
          whatsappTagsForm={whatsappTagsForm}
          setWhatsappTagsForm={setWhatsappTagsForm}
          attributesListLabel={attributesListLabel}
        />
        {renderAlerts()}
      </>
    )
  }
  if (modalFilterDataControl.open) {
    return (
      <ModalFilterData
        modalFilterDataControl={modalFilterDataControl}
        setModalFilterDataControl={setModalFilterDataControl}
        eventSchedules={eventSchedules}
        guestGroups={guestGroups}
        getFilteredData={getFilteredData}
        getTypeText={getTypeText}
      />
    )
  }
  if (modalLogControl.open) {
    return (
      <ModalLog
        modalLogControl={modalLogControl}
        setModalLogControl={setModalLogControl}
      />
    )
  }
  if (modalTrashControl.open) {
    return (
      <ModalTrash
        modalTrashControl={modalTrashControl}
        setModalTrashControl={setModalTrashControl}
        eventSchedules={eventSchedules}
        guestGroups={guestGroups}
        getTypeText={getTypeText}
        setModalLogControl={setModalLogControl}
      />
    )
  }
  if (modalErrorsControl.open) {
    return (
      <ModalErrorLog
        modalErrorsControl={modalErrorsControl}
        setModalErrorsControl={setModalErrorsControl}
      />
    )
  }
  return (
    <div>
      <CommandButtons
        modalFilterDataControl={modalFilterDataControl}
        setModalFilterDataControl={setModalFilterDataControl}
        getTrashDataAndOpenModal={getTrashDataAndOpenModal}
        getErrorsDataAndOpenModal={getErrorsDataAndOpenModal}
        openNewAction={openNewAction}
      />
      <ActionsList
        eventActions={eventActions}
        eventSchedules={eventSchedules}
        guestGroups={guestGroups}
        openEditAction={openEditAction}
        openCopyAction={openCopyAction}
        openDialogDeleteAction={openDialogDeleteAction}
        getTypeText={getTypeText}
        setModalLogControl={setModalLogControl}
      />
      {renderAlerts()}
    </div>
  );

  function renderAlerts() {
    return (
      <>
        <Loading loadingControl={loadingControl} />
        <Alert
          alertControl={alertControl}
          setAlertControl={setAlertControl}
        />
        <Dialog
          open={dialogActionControl.open}
          title={dialogActionControl.title}
          message={dialogActionControl.message}
          icon={dialogActionControl.icon}
          button1OnPress={() => tryDeleteAction()}
          button2OnPress={() => setDialogActionControl({ ...dialogActionControl, open: false, icon: 'info' })}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(AccreditationActionsPage);
